import { useUserAsParent } from 'app/dataProviders/user/hooks'

import { useSendersInfoData } from './useSendersInfoData'
import { useRecipientsInfoData } from './useRecipientsInfoData'


export function useTransferAvailability() {
  const parentID = useUserAsParent()

  const senders = useSendersInfoData()
  const recipients = useRecipientsInfoData()

  return !!parentID && senders.hasActiveSenders && recipients.hasActiveRecipients
}
